import ProfileIcon from "../../../assets/images/ProfileIcon";
import {
  Constants,
  DashboardConstants,
  StaffListConstants,
  StafflistConstants,
  UserStatus,
  UserStatusAction,
} from "../../../constants/constants";
import "./Staflist.css";
import SearchBar from "../../common/SearchBar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../store/store";
import { fetchStaffListAsync } from "../../../store/thunks/staffListThunk";
import { ApplicationInfo, STATUS } from "../../../store/slices/userDetailslice";
import PopupModal from "../../common/PopupModal";
import PopupModalWithCancelButton from "../../common/PopupModalWithCancelButton";
import ApproveIcon from "../../../assets/images/ApproveIcon";
import RejectIcon from "../../../assets/images/RejectIcon";
import DeactivateIcon from "../../../assets/images/DeactivateIcon";
import { getFormattedDate } from "../../../utils/DataTime";
import Loader from "../../common/styles/Loader";
import AddIcon from "../../../assets/images/AddIcon";
import LoaderPopupModel from "../../common/LoaderPopup";
import { saveActiveTabIndex } from "../../../store/slices/rolesSlice";
import { getUserValidationStatus } from "../../common/UserValidation";
import { PopUpModelForStaffExitFlow } from "../../common/PopUpModelForStaffExitFlow";
import { statusClassMap, userStatus } from "./StaffListComponent";
import StaffListPopups from "./StaffListPopups";
import { useTranslation } from "react-i18next";
import { readFromLocalStorage } from "../../../utils/DataEncryption";
export interface UserStatusRequestObj {
  status: string;
  userId: string;
}
const StaffListAndroid = ({
  staffList,
  title,
  pendingStaff,
  showErrorMessage,
  isEkycVerified,
  getMostRecentAppNameWithDate,
  updateUserStatus,
  handleDeactivateButton,
  routeUrl,
  handelRowsPerPagechange,
  rowPerPageArray,
  rowsPerPageValue,
  currentPage,
  handlePageNumberChange,
  handleNextPage,
  handlePrevPage,
  totalPages,
  deleteUserStatus,
  updateStatus,
  popUpMsg,
  approveButtonClicked,
  showApprovedPopUp,
  approveUser,
  rejectButtonClicked,
  showDeActivateOptions,
  selectedExitFlowMethod,
  setSelectedExitFLowMethod,
  OnExitFlowPopUpContinue,
  OnExitFlowPopUpClose,
  closeModal,
  rejectUser,
  errorMsg,
  errorDeleteMsg,
  errorMsgStatus,
  key,
  pageNumber,
  show,
  isSalesmateApp,
}: {
  staffList: any;
  title: any;
  pendingStaff: any;
  showErrorMessage: boolean;
  isEkycVerified: any;
  getMostRecentAppNameWithDate: any;
  updateUserStatus: any;
  handleDeactivateButton: any;
  routeUrl: any;
  handelRowsPerPagechange: any;
  rowPerPageArray: any;
  rowsPerPageValue: any;
  currentPage: any;
  handlePageNumberChange: any;
  handleNextPage: any;
  handlePrevPage: any;
  totalPages: any;
  deleteUserStatus: any;
  updateStatus: any;
  popUpMsg: string;
  approveButtonClicked?: boolean;
  showApprovedPopUp?: boolean;
  setShowApprovedPopUp?: any;
  show: boolean;
  setShow?: any;
  approveUser?: any;
  rejectButtonClicked: boolean;
  showDeActivateOptions: boolean;
  selectedExitFlowMethod: any;
  setSelectedExitFLowMethod: any;
  OnExitFlowPopUpContinue: any;
  OnExitFlowPopUpClose: any;
  closeModal: any;
  rejectUser: any;
  errorMsg: string | null;
  errorDeleteMsg: string;
  errorMsgStatus: boolean;
  key?: any;
  pageNumber: string;
  isSalesmateApp: any;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { t, i18n } = useTranslation();
  
  return (
    <div>
      <div className="bg-whiteColor rounded-[10px] border border-[rgba(162,161,168,0.4)]  text-white  py-4">
        <div className="w-full ">
          <div className="flex  justify-between ">
            <div className="flex flex-col items-start px-3 gap-2 pb-4">
              <div className="appName text-StaffListHeaderColor font-poppins ">
                {title ? title : t('EmployeeList')}
              </div>
              <div className="quickLinksDescription text-primary bg-sideMenubackground border border-hoverButton rounded-3xl px-1 py-[2px] flex justify-center items-center">
                {`${staffList?.staffList?.totalCount || 0} ${t('members')}`}
  
              </div>
            </div>

            <SearchBar from="Staff"/>
          </div>
          <div className="h-[740px] overflow-hidden overflow-y-auto overflow-x-auto scrollbar-hide ">
            {pendingStaff.loading ? (
              <Loader />
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 px-2 gap-4 ">
                {staffList.staffList?.data?.map((data: any, index: number) => {
                  const hideAction =
                    data?.id.toString() === localStorage.getItem("userId");
                  const userValidationStatus = getUserValidationStatus(
                    data?.consentStatus,
                    data?.ekycStatus
                  );
                  const ekycVerifiedStatus = isEkycVerified(
                    data?.ekycStatus,
                    data?.consentStatus,
                    data?.isEkycEnabled
                  );
                  const mostRecentAppDetail: ApplicationInfo | null =
                    getMostRecentAppNameWithDate(data?.loginDetails);
                  return (
                    <div
                      data-testid="staff-list-card"
                      key={index}
                      className="bg-white  rounded-xl p-3   cursor-pointer hover:shadow-lg border border-gray-300"
                      onClick={() => {
                        const apps = JSON.parse(
                          readFromLocalStorage("applications") || "[]"
                        );
                        // If apps is array of strings
                        if (
                          Array.isArray(apps) &&
                          apps.some((app) =>
                            [
                              "salesmate-app",
                              "salesmate-asa-app",
                            ].includes(app)
                          )
                        ) {
                          console.log(
                            "Navigation disabled for Salesmate users"
                          );
                          return; // do nothing
                        }

                        // If apps is array of objects: [{ applicationName: "salesmate-app" }]
                        if (
                          Array.isArray(apps) &&
                          apps.some((app) =>
                            [
                              "salesmate-app",
                              "salesmate-asa-app",
                            ].includes(app.applicationName)
                          )
                        ) {
                          console.log(
                            "Navigation disabled for Salesmate users"
                          );
                          return; // do nothing
                        }
                        navigate(`/StaffDetail/${data?.id}`)}}
                    >
                      {/* Name */}
                      <div className="flex justify-between items-start  border-b-[0.4px] border-sideMenuHelpBox border-opacity-40">
                        <div className="flex items-center justify-start pr-8">
                          {data?.profilePhotoUrl ? (
                            <img
                              className="h-9 w-9 rounded-full object-cover"
                              src={data.profilePhotoUrl}
                              alt="profile photo"
                            />
                          ) : (
                            <ProfileIcon />
                          )}
                          <div>
                            <div className="body2 font-bold text-primary">
                              {data?.firstName}
                            </div>
                            <div className="text-gray-600 label mb-3">
                              {data?.baseRoles?.map(
                                (roleData: any, index: number) => (
                                  <span key={index}>
                                    {roleData?.role?.name}
                                    {index !== data.baseRoles.length - 1 &&
                                      ", "}
                                  </span>
                                )
                              )}
                            </div>
                          </div>
                        </div>

                        {/* EKYC Status & User Status */}
                        

                        <div className="flex justify-start items-start gap-2">
                        {!isSalesmateApp && (<div
                            className={`px-3 py-1 rounded-lg label ${userValidationStatus.backGroundColor} text-black`}
                          >
                            {userValidationStatus.status}
                          </div>)}
                          <div
                            className={`px-3 py-1 rounded-lg text-white label 
                             ${statusClassMap[data?.status]}`}
                          >
                            {userStatus[data?.status]}{" "}
                          </div>
                        </div>
                      </div>
                      <hr className=" mb-2 bg-dividerColor h-[1px] "></hr>
                      <div className="flex justify-between items-start ">
                        <div className="flex items-center gap-3 mb-3">
                          <div className="flex flex-col">
                          <div>
                            <div className="label text-black ">
                              {t('Id')}
                            </div>
                            <div className="text-black employeeId mb-3">
                              {data?.professionalDetails?.employeeId ?? "NA"}
                            </div>
                          </div>
                          <div>
                            <div className="label text-black ">
                              {t('UID')}
                            </div>
                            <div className="text-black employeeId mb-3">
                              {data?.professionalDetails?.employeeId ?? "NA"}
                            </div>
                          </div>
                          </div>
                        </div>
                        <div className="flex items-center gap-3 mb-3">
                          <div>
                            <div className="label text-black ">
                              {t('Last')}{" "}
                            </div>
                            {mostRecentAppDetail != null &&
                            mostRecentAppDetail != undefined ? (
                              <div className="text-black employeeId mb-3">
                                {getFormattedDate(
                                  mostRecentAppDetail?.lastLogin
                                )}
                              </div>
                            ) : (
                              <div className="text-center text-black employeeId mb-3">
                                NA
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Add Role & Actions */}
                    
                      <div className="flex justify-between items-center pt-4">
                      {!isSalesmateApp &&
                        <div className="flex items-center gap-3 mb-3">
                          <div>
                            <div className="MobileResponsivesStatusText text-black ">
                              {t('Roles')}{" "}
                            </div>
                            <button
                              data-testid="add-role-button"
                              className="text-primary flex items-center"
                              onClick={(e) => {
                                e.stopPropagation();
                                dispatch(saveActiveTabIndex(2));
                                navigate(`/StaffDetail/${data?.id}`);
                              }}
                            >
                              <AddIcon height="12px" width="12px" />
                              <div className="ml-1 employeeId  ">Add </div>
                            </button>
                          </div>
                        </div>
                }

                        <div className="flex gap-3">
                          {(data?.status === UserStatus.PENDING ||
                            data?.status === UserStatus.PASSIVE) && (
                            <button
                              disabled={!ekycVerifiedStatus && !isSalesmateApp}
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent the card's onClick from being triggered
                                updateUserStatus(
                                  data?.status === UserStatus.PASSIVE
                                    ? UserStatusAction.ACTIVATE
                                    : Constants.AcceptUser,
                                  data?.id
                                );
                              }}
                              className={`${
                                ekycVerifiedStatus || isSalesmateApp
                                  ? "text-green-500"
                                  : "text-gray-400 cursor-not-allowed"
                              }`}
                            >
                              <ApproveIcon
                                height="24px"
                                width="24px"
                                bgColor={
                                  ekycVerifiedStatus|| isSalesmateApp ? "#ECF5EE" : "#F4F4F4"
                                }
                                iconColor={
                                  ekycVerifiedStatus|| isSalesmateApp ? "#449F52" : "#B3B3B3"
                                }
                              />
                            </button>
                          )}
                          {data?.status === UserStatus.PENDING && (
                            <button
                            data-testid="reject-button"
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent the card's onClick from being triggered
                                updateUserStatus(
                                  Constants.RejectUser,
                                  data?.id
                                );
                              }}
                              className="text-red-500"
                            >
                              <RejectIcon height="24px" width="24px" />
                            </button>
                          )}

                          {!hideAction &&
                            data?.status !== UserStatus.INACTIVE &&
                            data?.status !== UserStatus.PENDING && (
                              <button
                              data-testid="deactivate-button"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent the card's onClick from being triggered
                                  handleDeactivateButton(data?.id);
                                }}
                                className="text-gray-600"
                              >
                                <DeactivateIcon height="24px" width="24px" />
                              </button>
                            )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {showErrorMessage && (
              <div className="">
                <div
                  className="bg-red-100 border border-red-400 text-red-700 py-2 px-4 text-center rounded relative mt-5"
                  role="alert"
                >
                  <span className="block sm:inline">{t('noMoreDataToShow')}</span>
                </div>
              </div>
            )}

            <StaffListPopups
              updateStatus={updateStatus}
              deleteUserStatus={deleteUserStatus}
              STATUS={STATUS}
              show={show}
              approveButtonClicked={approveButtonClicked}
              popUpMsg={popUpMsg}
              approveUser={approveUser}
              closeModal={closeModal}
              rejectButtonClicked={rejectButtonClicked}
              rejectUser={rejectUser}
              showApprovedPopUp={showApprovedPopUp}
              errorMsg={errorMsg}
              errorDeleteMsg={errorDeleteMsg}
              currentPage={currentPage}
              rowsPerPageValue={rowsPerPageValue}
              keyVal={key}
              errorMsgStatus={errorMsgStatus}
              StaffListConstants={StaffListConstants}
              fetchStaffListAsync={fetchStaffListAsync}
            />
            {showDeActivateOptions && (
              <PopUpModelForStaffExitFlow
                selectedExitFlowMethod={selectedExitFlowMethod}
                setSelectedExitFLowMethod={setSelectedExitFLowMethod}
                OnExitFlowPopUpContinue={OnExitFlowPopUpContinue}
                OnExitFlowPopUpClose={OnExitFlowPopUpClose}
              />
            )}
          </div>
        </div>
      </div>
      {routeUrl[1] !== "dashboard" && (
        <div className="bg-sideMenubackground rounded-lg py-3">
          <div className="flex justify-between pr-8 pl-4">
            <div className="flex items-center">
              <div className="smallText text-popUpTitleColor">
                Rows per page
              </div>
              <div className="flex flex-row text-black">
                <div className="py-1 pl-2 mr-2 text-black ">
                  <select
                    id="rowPerpage"
                    onChange={handelRowsPerPagechange}
                    className="py-2 pl-2 pr-1 text-inputTextColor border border-hoverButton rounded-lg bg-whiteColor smallText"
                  >
                    <option selected className="hidden ">
                      {rowsPerPageValue}
                    </option>
                    <option value="10">{rowPerPageArray[0]}</option>
                    <option value="20">{rowPerPageArray[1]}</option>
                    <option value="30">{rowPerPageArray[2]}</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="pt-2.5">
              <div className="flex items-center smallText text-popUpTitleColor">
                Page
                <div className="px-2">
                  {/* <input type="text" id="number-of-pages" className="bg-whiteColor border border-hoverButton text-inputTextColor staffListHeader rounded-sm   p-2  w-6 h-6" 
                  //  placeholder={pageNumber} 
                   value={pageNumber}
                   onChange={handlePageNumberChange}
                   /> */}
                  <div
                    id="number-of-pages"
                    className="bg-whiteColor border border-hoverButton text-inputTextColor smallText rounded-sm text-center  p-2 h-7"
                    contentEditable
                    suppressContentEditableWarning
                    onInput={handlePageNumberChange}
                    style={{
                      display: "inline-block",
                      whiteSpace: "pre-wrap",
                      overflowWrap: "break-word",
                    }}
                  >
                    {currentPage}
                  </div>
                </div>
                <div className="smallText"> of {totalPages}</div>
              </div>
            </div>
            <div className="flex items-center">
            {totalPages > 1 && currentPage !== 1 &&(
              <div className=" flex border border-primary px-2 py-1 rounded-lg bg-sideMenubackground">
                <button
                  disabled={currentPage === 1}
                  onClick={handlePrevPage}
                  style={{
                    fontSize: "10px",
                    color: "#183883",
                    fontWeight: "400",
                  }}
                >
                  {"Previous"}
                </button>
              </div>
            )}
             {totalPages > 1 && currentPage !== totalPages &&(
              <div className="pl-4">
                <div className=" flex border border-black px-2 py-1 rounded-lg bg-primary ">
                  <button
                    disabled={currentPage === totalPages}
                    onClick={handleNextPage}
                    style={{
                      fontSize: "10px",
                      color: "#FFF",
                      fontWeight: "400",
                    }}
                  >
                    {"Next"}
                  </button>
                </div>
              </div>
             )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StaffListAndroid;
